/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Concurrent_StreamInputs */



/**
* | output |
* | --- |
* | "Another response is already being generated for this chat." |
*
* @param {Chat_Error_Concurrent_StreamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_concurrent_stream = /** @type {((inputs?: Chat_Error_Concurrent_StreamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Concurrent_StreamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wird bereits eine Antwort für diesen Chat generiert.")
	return /** @type {LocalizedString} */ ("Another response is already being generated for this chat.")
});